var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagTurkey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15671_193960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1H28V19H1V1Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5251 10L17.5955 8.6776L15.0797 12.1399V7.8601L17.5955 11.3224L13.5251 10ZM13.8026 12.4063C13.2812 13.2302 12.5064 13.8624 11.5947 14.208C10.683 14.5535 9.68377 14.5935 8.74734 14.3221C7.8109 14.0507 6.98794 13.4825 6.40229 12.7031C5.81665 11.9236 5.5 10.975 5.5 10C5.5 9.02503 5.81665 8.07643 6.40229 7.29695C6.98794 6.51746 7.8109 5.94927 8.74734 5.67787C9.68377 5.40646 10.683 5.44654 11.5947 5.79205C12.5064 6.13756 13.2812 6.76983 13.8026 7.5937C13.3157 7.05195 12.676 6.67062 11.9679 6.50008C11.2598 6.32953 10.5166 6.37779 9.83645 6.63849C9.15633 6.89919 8.57129 7.36006 8.1586 7.96023C7.7459 8.56039 7.52496 9.27163 7.52496 10C7.52496 10.7284 7.7459 11.4396 8.1586 12.0398C8.57129 12.6399 9.15633 13.1008 9.83645 13.3615C10.5166 13.6222 11.2598 13.6705 11.9679 13.4999C12.676 13.3294 13.3157 12.9481 13.8026 12.4063Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 19,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15671_193960"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTurkey);
export default __webpack_public_path__ + "static/media/FlagTurkey.cc6c0e33d9fca221c2ec321fbc1c0be0.svg";
export { ForwardRef as ReactComponent };